import { useEffect, useState } from "react";
import { useServiceRegister } from "contexts/register/ServiceContext";
import Input from "../../../Input";
import { OccurrenceToggleButton } from "../../../OccurrenceToggleButton";

import * as S from "./styles";
import { Button } from "components/Button";

export function ServiceForm() {
  const { services, setServices, service, errors, searching, setService, removeError } =
    useServiceRegister();
  const [toggled, setToggled] = useState(false);

  useEffect(() => {
    if (service.type === undefined) {
      setService((value) => {
        value.type = "Residencial";
        return value;
      });
    }
  }, []);

  if (searching) {
    return (
      <S.LoadingWrapper>
        <span>Buscando dados do usuário...</span>
      </S.LoadingWrapper>
    );
  }
  return (
    <div>
      <S.ProviderModalContent>
        <S.ProviderModalForm>
          <S.ProviderModalData>
            <Input
              id="service"
              name="service"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setService((value) => {
                  value.name = event.target.value;
                  return value;
                });
              }}
              label="Nome do serviço"
              defaultValue={service?.name}
              required={true}
              type="text"
              containerClassName="service-input"
              error={errors.name}
              apiErrorName={"name"}
              handleApiErrorRemove={() => removeError("name")}
            />
            <OccurrenceToggleButton
              response
              leftLabel="Residencial"
              rightLabel="Veículo"
              isEstablishment={service.type === "Residencial"}
              label="Selecione o tipo do serviço"
              leftClick={() => {
                setToggled(!toggled);
                setService((value) => {
                  value.type = "Residencial";
                  return value;
                });
              }}
              rightClick={() => {
                setToggled(true);
                setService((value) => {
                  value.type = "Veicular";
                  return value;
                });
              }}
            />
            <S.TextAreaContainer>
              <label htmlFor="service-description">Descrição</label>
              <textarea
                id="service-description"
                maxLength={250}
                defaultValue={service?.description}
                onFocus={() => removeError("description")}
                onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                  setService((value) => {
                    value.description = event.target.value;
                    return value;
                  });
                }}
              />
              {errors.description && <small>{errors.description}</small>}
            </S.TextAreaContainer>

            <S.AddButton>
              <Button type="submit" onClick={() => { setServices((value) => [...value, { ...service, active: true }]) }}>Adicionar</Button>
            </S.AddButton>
          </S.ProviderModalData>
          <S.AddedServices>
            {services.length > 0 && <label>Serviços que serão registrados</label>}
            {services.map((service) => service.active &&
              <div onClick={() => { setServices((value) => value.map((s) => { if (s.id === service.id) { s.active = false }; return s })) }}>
                <span>{service.name}</span>
                <span>{service.type}</span>
              </div>
            )}
          </S.AddedServices>
        </S.ProviderModalForm>
      </S.ProviderModalContent>
    </div>
  );
}
